import { Text } from '@qga/roo-ui/components';

import Skeleton from '@shared/v2/components/Skeleton';

import Button from '@/components/Button/Button';
import useCtaButton from '@/v2/components/pages/PackageView/hooks/useCtaButton';
import useCtaButtonStatus from '@/v2/components/pages/PackageView/hooks/useCtaButtonStatus';
import useHandleReserve from '@/v2/components/pages/PackageView/hooks/useHandleReserve';

const FooterCta = () => {
  const buttonStatus = useCtaButtonStatus();
  const handleReserve = useHandleReserve();
  const { handleClick, buttonText } = useCtaButton(buttonStatus, {
    isMobileVariant: true,
    handleReserve,
  });

  if (!buttonStatus) {
    return null;
  }

  return (
    // @ts-ignore - TS doesn't get styled-system props
    <Skeleton.Button width="100%">
      <Button
        px={3}
        width="100%"
        py="10px"
        variant="primary"
        onClick={handleClick}
      >
        <Text display="block" lineHeight="1.5" fontWeight="bold" fontSize="sm">
          {buttonText}
        </Text>
      </Button>
    </Skeleton.Button>
  );
};

export default FooterCta;
